import { withInstall } from '@ll-plus/utils'

import Link from './src/link.vue'

export const LlLink = withInstall(Link)
export default LlLink
export * from './src/link'

declare module 'vue' {
  export interface GlobalComponents {
    LlLink: typeof Link
  }
}
